// --------------------------------------------------------------------------
// General Data Protection Regulations (GDPR) Preferences Module
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var ref = { $root: options.context },
        $wrapper = $(document).find('[data-name="gdpr-wrapper"]'),
        $channelsWrapper = $wrapper.find('[data-name="gdpr-channels-wrapper"]'),
        $addressLookup = $(document).find('.address-lookup'),
        $addressContainer = $wrapper.find('[data-name="gdpr-contact-details-wrapper"]'),
        $addressDisplay = $wrapper.find('[data-name="gdpr-address-display"]'),
        addressSelectDropdownSelector = '[data-binding="address-select-dropdown"]',
        $editPost = ref.$root.find('[data-name="gdpr-channel-edit-post"]'),
        $reg = $(document).find('.registration-form-section--contact > fieldset'),
        $contactDetailsCancel = $wrapper.find('[data-name="gdpr-contact-details-cancel"]'),
        $contactDetailsSave = $wrapper.find('[data-name="gdpr-contact-details-save"]');

    function init() {
        ref.$root.on('change', '[data-name="contact-preference"]', function (event) {
            $(event.target).closest('[data-behavior="gdpr-preferences"]').toggleClass('gdpr-preferences__channel--selected-yes', event.target.value === 'True').toggleClass('gdpr-preferences__channel--selected-no', event.target.value === 'False');
        });

        ref.$root.each(function (index, el) {
            var $channel = $(el),
                $input = $channel.find('[data-name="gdpr-channel-field"] input'),
                prevVal = $input.val(),
                mirrorSelector = $channel.data('mirror-selector') || '',
                $mirrorInput = false,
                $channelText = $channel.find('[data-name="gdpr-channel-text-display"]');

            if (mirrorSelector.length) {
                $mirrorInput = $(document).find(mirrorSelector).first();
            }

            (function ($channel, $channelText, $input, prevVal, $mirrorInput, mirrorSelector) {
                var $fieldGroup;

                function updateChannelText() {
                    $channelText.html($mirrorInput.val());
                }

                // Returns true if a channel's mirrored input is optional
                function isOptionalField($channel) {
                    var $channelType = $channel.data('gdpr-channel');

                    // This will allow changing the required rule only for the phone and text fields
                    // which are optional; The email and post shouldn't have their validation rules changed
                    return $channelType === 'phone' || $channelType === 'text';
                }

                if ($mirrorInput.length) {
                    // move not only the mirrored input but the whole group
                    // that includes the validation error messages
                    $fieldGroup = $mirrorInput.closest('.field-group');
                    $mirrorInput.on('change', updateChannelText);

                    // Initialise channel text with inputs values
                    updateChannelText();
                }

                // EXIT
                function exitEditMode($channel, $mirrorInput, $fieldGroup) {
                    if ($mirrorInput.length) {
                        var $placeholder = $('[data-mirror-placeholder="' + mirrorSelector + '"]');

                        $placeholder.before($fieldGroup);
                        $placeholder.remove();
                    }

                    $channel.find('[data-name="gdpr-channel-text"]').show();
                    $channel.find('[data-name="gdpr-channel-field"]').hide();
                }

                // ENTER
                function enterEditMode($input, $channel, $mirrorInput, $fieldGroup) {
                    // search for the existing placeholder (would mean the channel is already in the edit mode)
                    var $placeholder = $('[data-mirror-placeholder="' + mirrorSelector + '"]');

                    if ($placeholder.length === 0 && $mirrorInput.length) {
                        // add a placeholder in DOM where the moved input should be brought back
                        $fieldGroup.before('<div data-mirror-placeholder="' + mirrorSelector + '"></div>');

                        $fieldGroup.prependTo($channel.find('[data-name="gdpr-channel-field"]'));
                        prevVal = $mirrorInput.val();
                    }

                    $channel.find('[data-name="gdpr-channel-text"]').hide();
                    $channel.find('[data-name="gdpr-channel-field"]').show();
                    $input.focus().select();
                }

                /* YES */
                $channel.find('[data-name="contact-preference"]:eq(0)').on('click', function () {
                    if ($mirrorInput.length) {
                        if (isOptionalField($channel)) {
                            $mirrorInput.rules('add', { required: true });
                        }

                        // open the input field if the value is invalid
                        if (false === $mirrorInput.valid()) {
                            enterEditMode($input, $channel, $mirrorInput, $fieldGroup);
                        }
                    }
                });

                /* NO */
                $channel.find('[data-name="contact-preference"]:eq(1)').on('click', function () {
                    if ($mirrorInput.length) {
                        if (isOptionalField($channel)) {
                            $mirrorInput.rules('remove', 'required');
                        }

                        exitEditMode($channel, $mirrorInput, $fieldGroup);
                    }
                });

                /* EDIT */
                $channel.find('[data-name="gdpr-channel-edit"]').on('click', function (e) {
                    e.preventDefault();

                    enterEditMode($input, $channel, $mirrorInput, $fieldGroup);
                });

                /* CANCEL */
                $channel.find('[data-name="gdpr-channel-cancel"]').on('click', function (e) {
                    e.preventDefault();

                    // restore the previous value of the mirrored input
                    $mirrorInput.val(prevVal);
                    $channelText.html(prevVal);

                    // invalid contact value, mark the channel as "No", otherwise
                    // the DP channel will have invalid contact value
                    if (false === $mirrorInput.valid()) {
                        $channel.find('[data-name="contact-preference"]:eq(1)').trigger('click');
                    }

                    exitEditMode($channel, $mirrorInput, $fieldGroup);
                });

                /* DONE */
                $channel.find('[data-name="gdpr-channel-done"]').on('click', function (e) {
                    e.preventDefault();

                    if ($mirrorInput.valid()) {
                        exitEditMode($channel, $mirrorInput, $fieldGroup);

                        var updatedTextValue = $mirrorInput.length ? $mirrorInput.val() : $input.val();
                        $channel.find('[data-name="gdpr-channel-text-display"]').html(updatedTextValue);
                    }
                });
            })($channel, $channelText, $input, prevVal, $mirrorInput, mirrorSelector);
        });

        function hideContactDetails($addressContainer, $channelsWrapper) {
            $addressContainer.fadeOut(250, function () {
                var $placeholder = $('[data-mirror-placeholder="gdpr-address-lookup"]');
                $placeholder.before($addressLookup);
                $placeholder.remove();

                $channelsWrapper.fadeIn(250);
            });
        }

        $contactDetailsCancel.on('click', function (e) {
            e.preventDefault();

            $addressDisplay.html($('[data-binding="address-part-postcode"]').val());

            hideContactDetails($addressContainer, $channelsWrapper);
        });

        function updateAddressDisplayText($addressDisplay) {
            $addressDisplay.html($('[data-binding="address-part-postcode"]').val());
        }

        $contactDetailsSave.on('click', function (e) {
            e.preventDefault();

            updateAddressDisplayText($addressDisplay);

            hideContactDetails($addressContainer, $channelsWrapper);
        });

        $editPost.on('click', function () {
            $addressLookup.before('<div data-mirror-placeholder="gdpr-address-lookup"></div>');

            $addressLookup.prependTo($addressContainer);
            $channelsWrapper.fadeOut(250, function () {
                $addressContainer.fadeIn(250);
            });

            $reg.find('.field-group').hide();
        });

        $(document).on('change', addressSelectDropdownSelector, function () {
            updateAddressDisplayText($addressDisplay);
        });

        updateAddressDisplayText($addressDisplay);
    }

    function valid() {
        var valid = {
            errors: [],
            result: true
        };

        $('[data-behavior="gdpr-preferences"]').each(function (index, el) {
            var $channel = $(el),
                mirrorSelector = $channel.data('mirror-selector') || '',
                $mirrorInput = false,
                fieldType;

            if (!$channel.hasClass('gdpr-preferences__channel--selected-yes') && !$channel.hasClass('gdpr-preferences__channel--selected-no')) {
                valid.result = false;
                valid.errors.push({ message: 'Please click "Yes please" or "No thanks".' });
            } else {
                if (mirrorSelector.length) {
                    var regex;
                    $mirrorInput = $(document).find(mirrorSelector).first();

                    if ($channel.hasClass('gdpr-preferences__channel--selected-yes')) {
                        switch ($mirrorInput.data('binding')) {
                            case 'contact-details-phone-number':
                                fieldType = 'phone number';
                                regex = /[0-9\s]{10,11}/;

                                // check if phone number is present
                                if ($mirrorInput.val().length === 0) {
                                    valid.result = false;
                                    valid.errors.push({ message: 'Please enter your ' + fieldType + '.' });
                                } else {
                                    if (!regex.test($mirrorInput.val())) {
                                        valid.result = false;
                                        valid.errors.push({ message: '\'' + $mirrorInput.val() + '\' is not a valid ' + fieldType + '.' });
                                    }
                                }

                                break;

                            case 'contact-details-email-address':
                                fieldType = 'email address';
                                regex = /.+@.+\.+/;
                                if ($mirrorInput.val().length === 0) {
                                    valid.result = false;
                                    valid.errors.push({ message: 'Please enter your ' + fieldType + '.' });
                                } else {
                                    if (!regex.test($mirrorInput.val())) {
                                        valid.result = false;
                                        valid.errors.push({ message: '\'' + $mirrorInput.val() + '\' is not a valid ' + fieldType + '.' });
                                    }
                                }
                                break;

                            case 'contact-details-mobile-number':
                                fieldType = 'mobile number';
                                regex = /[0-9\s]{10,11}/;
                                if ($mirrorInput.val().length === 0) {
                                    valid.result = false;
                                    valid.errors.push({ message: 'Please enter your ' + fieldType + '.' });
                                } else {
                                    if (!regex.test($mirrorInput.val())) {
                                        valid.result = false;
                                        valid.errors.push({ message: '\'' + $mirrorInput.val() + '\' is not a valid ' + fieldType + '.' });
                                    }
                                }
                                break;
                        }
                    } // if ($channel.hasClass('gdpr-preferences__channel--selected-yes'))
                } // if (mirrorSelector.length)
            }
        });

        return valid;
    }

    return {
        init: init,
        valid: valid
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/gdpr-preferences.js
// module id = 62
// module chunks = 0